import React from 'react';

export const WizardSeparator = () => {
  return (
    <div
      data-testid="wizard-separator"
      className="border-border-default ms-24 h-8 w-1 border-l-1"
    />
  );
};
